import Button from "devextreme-react/button";
import { useState } from "react";
import { AddNoteButtonProps } from "../types/AddNoteButtonProps";
import AddNotePopup from './AddNotePopup';

export default function AddNoteButton(props: AddNoteButtonProps) {

	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<Button
				text={props.caption}
				icon="Inscyth-Add"
				elementAttr={{ 'data-testid': 'btn-add-note' }}
				onClick={() => setPopupVisibility(true)}>
			</Button>
			{
				isPopupVisible &&
				<AddNotePopup
					caption={props.caption}
					params={props.params}
					onHidePopup={() => setPopupVisibility(false)} />
			}
		</>
	)
}
